if (typeof AnnouncementBar !== "function") {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.slider = this.querySelector("[data-js-slider]");
      this.content = this.querySelectorAll(".announcement");
      this.nextButton = this.querySelector(
        ".announcement-bar__content-nav--right"
      );
      this.prevButton = this.querySelector(
        ".announcement-bar__content-nav--left"
      );

      this.index = 0;
      this.length = this.content.length;
      this.autoRotateTimer = null; // Holds the timer for auto-rotation

      if (this.nextButton) {
        this.nextButton.addEventListener("click", () => {
          this.changeSlide("next");
        });
      }
      if (this.prevButton) {
        this.prevButton.addEventListener("click", () => {
          this.changeSlide("prev");
        });
      }

      this.addEventListener("mouseenter", () => this.stopAutoRotate());
      this.addEventListener("mouseleave", () => this.startAutoRotate());

      this.startAutoRotate(); // Start auto-rotation on initialization
    }

    changeSlide(direction) {
      this.nextButton.classList.remove(
        "announcement-bar__content-nav--disabled"
      );
      this.prevButton.classList.remove(
        "announcement-bar__content-nav--disabled"
      );

      if (direction == "next") {
        this.index++;
        if (this.index >= this.length) {
          // Loop back to the first item
          this.index = 0;
        }
      } else if (direction == "prev") {
        this.index--;
        if (this.index < 0) {
          // Loop to the last item
          this.index = this.length - 1;
        }
      }

      if (this.index == this.length - 1) {
        this.nextButton.classList.add(
          "announcement-bar__content-nav--disabled"
        );
      } else if (this.index == 0) {
        this.prevButton.classList.add(
          "announcement-bar__content-nav--disabled"
        );
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: "smooth",
      });
    }

    startAutoRotate() {
      this.autoRotateTimer = setInterval(() => this.changeSlide("next"), 5000);
    }

    stopAutoRotate() {
      clearInterval(this.autoRotateTimer);
    }
  }

  if (typeof customElements.get("announcement-bar") == "undefined") {
    customElements.define("announcement-bar", AnnouncementBar);
  }
}
